import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import * as krakenModels from '@/model/config/krakenModels';

export type RegisterModalActionsCallback = Sender<{
  type: 'REGISTER_MODAL_STATE_CLOSED';
  data: object | { payload: object };
}>;

export const watchRegisterModalActions = () => {
  return asyncCallback(async (callback: RegisterModalActionsCallback) => {
    const watcherOptions = {
      callback,
    };

    return await krakenModels.registerWatcher(watcherOptions);
  });
};
